import Axios from "axios";
import { getResponseData } from "../../utils/helper";
import { getBaseUrl, palateDiscoveryLinks } from "../../utils/links";
const CancelToken = Axios.CancelToken;

export let getPalateDiscoveryAssignmentCancelToken = undefined;
export const getPalateDiscoveryAssignment = (token) => {
  if (getPalateDiscoveryAssignmentCancelToken) getPalateDiscoveryAssignmentCancelToken();
  let url = `${getBaseUrl()}${palateDiscoveryLinks.assignment}`,
    options = {
      url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      cancelToken: new CancelToken((c) => (getPalateDiscoveryAssignmentCancelToken = c)),
    };
  return Axios(options)
    .then((response) => {
      let successData = getResponseData(response);
      if (successData) {
        return successData;
      } else {
        throw response;
      }
    })
    .catch((error) => {
      throw error;
    });
};



export let PalateDiscoveryAssignmentDismissCancelToken = undefined;
export const getPalateDiscoveryAssignmentDismiss = (token , id) => {
  if (PalateDiscoveryAssignmentDismissCancelToken) PalateDiscoveryAssignmentDismissCancelToken();
  let url = `${getBaseUrl()}${palateDiscoveryLinks.dismiss(id)}`,
    options = {
      url,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      cancelToken: new CancelToken((c) => (PalateDiscoveryAssignmentDismissCancelToken = c)),
    };
  return Axios(options)
    .then((response) => {
      let successData = getResponseData(response);
      return successData;
    })
    .catch((error) => {
      throw error;
    });
};



